
@charset "UTF-8";
/*  Variable
   ========================================================================== */
/*  breakpoint
   ========================================================================== */
/*  Misc
   ========================================================================== */
/*  Section Colors
   ========================================================================== */
/*  The Big Guns
   ========================================================================== */
/*  The Next Wave
   ========================================================================== */
/*  Start Ups
   ========================================================================== */
/*  Future Tech
   ========================================================================== */
/*  Reviewed
   ========================================================================== */
/*  Tried & Tested
   ========================================================================== */
/*  Digital Life
   ========================================================================== */
/*  Other Colors
   ========================================================================== */
/*  Generic Colors
   ========================================================================== */
/*  Article Body Colors
   ========================================================================== */
/*  Footer
   ========================================================================== */
/*  AMP
   ========================================================================== */
@import url(./css/bootstrap.customized.css);
@import url(./css/animate.css);
@import url(./css/customAnimations.css);
/* latin */
@import url(~vue-resize/dist/vue-resize.css);
@import url("https://fonts.googleapis.com/css?family=Barlow:400,400i,600,600i,700,700i,900,900i|Roboto:400,400i,700,700i|Bungee|Bungee+Inline|Bungee+Shade|PT+Sans");
@font-face {
  font-family: 'DroidSans';
  font-style: normal;
  font-weight: normal;
  src: local("Barlow Regular"), local("Barlow-Regular"), url(https://fonts.gstatic.com/s/barlow/v1/7cHpv4kjgoGqM7E_DMs5ynghnQ.woff2) format("woff2"), url(https://fonts.gstatic.com/s/barlow/v1/7cHpv4kjgoGqM7E_DMs_ynghnQ.woff) format("woff");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: 'DroidSans';
  font-style: normal;
  font-weight: bold;
  src: local("Barlow SemiBold"), local("Barlow-SemiBold"), url(https://fonts.gstatic.com/s/barlow/v1/7cHqv4kjgoGqM7E30-8s6Vostz0rdom9.woff2) format("woff2"), url(https://fonts.gstatic.com/s/barlow/v1/7cHqv4kjgoGqM7E30-8s51oqtz0rdg.woff) format("woff");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: 'Silkscreen';
  src: url("../static/fonts/Silkscreen/slkscr.ttf") format("truetype"), url("../static/fonts/Silkscreen/slkscr-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: '04bregular';
  src: url("../static/fonts/04b03/04b03.eot") format("embedded-opentype"), url("../static/fonts/04b03/04b03.woff2") format("woff2"), url("../static/fonts/04b03/04b03.woff") format("woff"), url("../static/fonts/04b03/04b03.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
html {
  font-size: 16px;
  min-width: 320px;
}
.lock-screen {
  overflow: hidden;
  max-width: 100vw;
  max-height: 100vh;
}
body {
  counter-reset: section;
  font-family: "Roboto", sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
h1 {
  font-size: 2rem;
  line-height: 2.375rem;
  font-weight: bold;
  color: #000000;
}
h2 {
  font-size: 1.125rem;
  line-height: 1.625rem;
  color: #000000;
}
h3 {
  color: #F8008E;
  font-size: 1.25rem;
  line-height: 1.625rem;
  text-transform: uppercase;
  font-weight: bold;
  /* Mobile breakpoints */
}
@media (min-width: 1024px) {
h3 {
      margin-bottom: 0.5rem;
}
}
.article-body-text h3 {
    margin-top: 2.25rem;
    font-family: "Barlow", sans-serif;
}
h4 {
  font-size: 1.5rem;
  line-height: 1.75rem;
  font-weight: bold;
  color: #000000;
}
h5, h5 a, h5 a:hover, h5 a:visited {
  color: #F8008E;
}
h5 {
  font-size: 1.125rem;
  line-height: 1.875rem;
}
h6 {
  color: #F8008E;
  font-size: 1rem;
  line-height: 1.1875rem;
  font-weight: bold;
  text-transform: uppercase;
}
a {
  text-decoration: none;
}
a.link,
.article-body a {
  color: #222222;
  -webkit-text-decoration: underline #f8008e;
          text-decoration: underline #f8008e;
  border-bottom: 0;
  -webkit-text-decoration-style: solid;
          text-decoration-style: solid;
}
a.link:hover,
  .article-body a:hover {
    -webkit-text-decoration: underline #FF5CBE;
            text-decoration: underline #FF5CBE;
    /* Mobile breakpoints */
}
@media (min-width: 0) and (max-width: 1023px) {
a.link:hover,
      .article-body a:hover {
        -webkit-text-decoration: underline #BF0061;
                text-decoration: underline #BF0061;
}
}
a.link:focus,
  .article-body a:focus {
    -webkit-text-decoration: underline #BF0061;
            text-decoration: underline #BF0061;
}
p {
  /* Mobile breakpoints */
  /* Mobile breakpoints */
}
@media (min-width: 1024px) {
p {
      font-size: 1.25rem;
      line-height: 1.875rem;
}
}
@media (min-width: 0) and (max-width: 1023px) {
p {
      font-size: 1.125rem;
      line-height: 1.75rem;
}
}
.article-body ul,
.article-body ol {
  list-style-type: none;
  padding-left: 2.9375rem;
}
.article-body ul li,
  .article-body ol li {
    color: #222222;
    font-size: 1.125rem;
    line-height: 1.625rem;
    margin-bottom: 1.25rem;
}
.article-body ul li:before,
    .article-body ol li:before {
      content: '• ';
      color: #00E8FF;
      position: absolute;
      margin-left: -1.25rem;
      font-family: "PT Sans", sans-serif;
      font-weight: bold;
      font-size: 1.0625rem;
      /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.article-body ul li:before,
        .article-body ol li:before {
          font-size: 1.25rem;
}
}
.article-body ol {
  counter-reset: section;
}
.article-body ol li:before {
    counter-increment: section;
    content: counter(section);
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-family: Bungee, sans-serif;
    width: 3rem;
    text-align: right;
    margin-left: -3.625rem;
    margin-top: 0.1875rem;
}
.article-body strong {
  font-weight: bold;
}
.article-body figcaption {
  background-color: #18FFFF;
  color: #222222;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 0.5rem;
  /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.article-body figcaption {
      line-height: 1.125rem;
      font-size: 0.9375rem;
      padding: 0.75rem 1.5rem;
}
}
.product-name {
  color: #222222;
  font-family: "Bungee Shade", sans-serif;
  font-size: 2.25rem;
  line-height: 2.25rem;
  z-index: 2;
  position: relative;
}
.product-score {
  color: #222222;
  font-family: Bungee, sans-serif;
  font-size: 3rem;
  line-height: 3rem;
}
.product-rating {
  color: #222222;
  font-size: 1.5rem;
  margin-top: -1.625rem;
  margin-bottom: 0.75rem;
  position: relative;
  line-height: 7.5rem;
  z-index: 1;
}
.product-rating:before, .product-rating:after {
    position: absolute;
    content: '';
    background-color: #18FFFF;
    top: 0;
    left: 50%;
    z-index: -1;
    -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
            transform: rotate(45deg);
}
.product-rating:before {
    width: 5.625rem;
    height: 5.625rem;
    margin-top: 0.9375rem;
    margin-left: -2.8125rem;
    -webkit-animation: rotating 2s linear 0s infinite;
            animation: rotating 2s linear 0s infinite;
    animation-direction: reverse;
}
.product-rating:after {
    width: 7.5rem;
    height: 7.5rem;
    margin-left: -3.75rem;
    -webkit-animation: rotating 3s linear 0s infinite;
            animation: rotating 3s linear 0s infinite;
    opacity: 0.4;
}
.taxonomy {
  font-size: 0.875rem;
  line-height: 1rem;
  font-weight: bold;
  color: #222222;
  text-transform: uppercase;
}
.methode-html-wrapper iframe, .methode-html-wrapper twitterwidget {
  margin: auto;
}
.container {
  padding-left: 15px;
  padding-right: 15px;
}
.row-reverse {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
}
.full-width {
  width: 100%;
}
.grayscale {
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
}
.scrollable-wrapper {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  /*
   * FIX: Jittering Scroll
   *
   * Elements will be chopped off after scrolling and apply translate3d to them
   */
}
.scrollable-wrapper * .disable-translate3d {
    -webkit-transform: none;
}
.vw-100 {
  width: 100vw;
}
.scroll-x-hidden {
  overflow-x: hidden;
}
html.freeze {
  overflow: initial;
}
html.freeze body {
    position: inherit;
    overflow: initial;
}
html.freeze body .scroll-x-hidden {
      overflow: initial;
}
html.freeze body .navigation__hamburgerMenu.desktop {
      right: 0;
      left: 100%;
      margin-left: -3.1875rem;
}
html.freeze body .viewunit-detection {
      width: 100%;
}
html.freeze body .footer-wrap.vw-100 {
      width: 100%;
}
iframe.instagram-media {
  border: 1px solid red;
  margin: auto !important;
}
.fade-enter-active {
  -webkit-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}
.fade-leave-active {
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@-webkit-keyframes rotating {
from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
}
}
@keyframes rotating {
from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
}
}
@-webkit-keyframes quoteFlickering {
50% {
    fill: #18FFFF;
}
}
@keyframes quoteFlickering {
50% {
    fill: #18FFFF;
}
}
@-webkit-keyframes quoteFlickeringReverse {
50% {
    fill: #76FFFF;
}
}
@keyframes quoteFlickeringReverse {
50% {
    fill: #76FFFF;
}
}
html {
  overflow-x: hidden;
  overscroll-behavior-y: contain;
}
body {
  position: fixed;
  overflow: hidden;
  width: 100%;
  height: 100%;
  overscroll-behavior-y: contain;
}
#app {
  height: 100%;
}
input::-ms-clear {
  display: none;
}
.modal-footer {
  padding: 0;
  border: none;
  display: inline;
}
@media (min-width: 1024px) {
.modal-lg {
    max-width: 22.3125rem;
}
}
#app {
  background-color: #012b55;
}
.route-transition-fade-enter-active {
  -webkit-transition: opacity .5s ease-in;
  -o-transition: opacity .5s ease-in;
  transition: opacity .5s ease-in;
}
.route-transition-fade-leave-active {
  -webkit-transition: opacity .1s;
  -o-transition: opacity .1s;
  transition: opacity .1s;
}
.route-transition-fade-enter,
.route-transition-fade-leave-to {
  opacity: 0;
}
.viewunit-detection {
  position: absolute;
  z-index: -1;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
}
.loader-overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.7);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  vertical-align: center;
}
.loader-overlay .loader {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
        -ms-flex: 1;
            flex: 1;
}



// WEBPACK FOOTER //
// ./assets/App.vue